import { z } from "zod/v4";

export const WorkspaceSchema = z.object({
	id: z.string(),
	name: z.string().default(""),
	host: z.string().default(""),
	slug: z.string().default(""),
	role: z.enum(["owner", "member", "guest"]).default("guest"),
	owner: z.boolean().default(false),
});

export type Workspace = z.infer<typeof WorkspaceSchema>;
